<template>
    <div id="pdf_container" v-show="showPDF" v-on:click="destroy">
        <div id="viewerContainer"></div>
        <button id="closePDF" v-on:click="destroy">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                 id="Capa_1" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;"
                 xml:space="preserve" width="30px" height="30px" class=""><g>
                <circle cx="25" cy="25" r="25" data-original="#D75A4A" class="active-path" data-old_color="#353232" fill="#363333"/>
                <polyline style="stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;" points="16,34 25,25 34,16   " stroke="#ffffff" fill="#ffffff"/>
                <polyline style="stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;" points="16,16 25,25 34,34   " stroke="#ffffff" fill="#ffffff"/></g>
            </svg>
        </button>
    </div>
</template>

<script>

    import Vue from 'vue';
    import router from '@js/routes';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import EventBus from '@common/eventBus';
    import api from '@js/api';
    import axios from 'axios';

    export default {

        name: "PDFViewer",
        mixins:[common,storeMapper],
        data() {
            return {
                showPDF: false,
            }
        },
        methods: {
            viewPdf(json)
            {
                this.showPDF = true;
                let pdf_url = json.preview;
                let original_url = json.url;

                var url = pdfViewerUrl+"?file="+encodeURIComponent(pdf_url)+"&url="+encodeURIComponent(original_url);
                document.getElementById("viewerContainer").innerHTML='<object type="text/html" data="'+url+'" ></object>';


            },
            destroy()
            {
                this.showPDF = false;
            }
        }
    }
</script>

<style>
    #pdf_container {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1000000;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.5);
        overflow: scroll;
    }

    #viewerContainer {
        width: 80%;
        height: 100%;
        margin: 0 auto;
    }

    #viewerContainer object {
        width: 100%;
        height: 100%;
    }

    #closePDF {
        position: absolute;
        top: 15px;
        right: 15px;
        background: unset;
        border: 0;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/player/PDFViewer.vue